<template>
  <div class="configuration-wizard-create-event">
    <mj-configuratin-wizard-header>
      <template #headline>
        Event erstellen
      </template>
      <template #info-text>
        Vor jeder Playlist steht immer ein Event. Da es reichlich gründe zum feiern gibt,
        sind wir davon überzeugt das wir das richtige Event einfällt.
      </template>
      <template #progress-bar>
        <mj-configuratin-wizard-progress-bar
          :current-step="2"
          :labels="progressLabels"
        />
      </template>
    </mj-configuratin-wizard-header>
    <mj-configuratin-wizard-content>
      <mj-validation-observer
        id="create-event"
        ref="formObserver"
        tag="form"
        method="post"
        @submit.prevent="onSubmit"
      >
        <div class="flex flex-col w-full md:flex-row mb-12">
          <div class="configuration-wizard-create-event__event-name mr-12 w-full md:w-1/2">
            <mj-input-label
              for="eventname"
              class="text-xl text-gray-900"
            >
              Wie möchtest du dein erstes Event nennen?
            </mj-input-label>
            <p class="text-gray-700 text-xs">
              Du kannst den Namen im nachhinein jederzeit ändern.
            </p>
            <mj-validation-input-field
              v-model="eventForm.name"
              name="eventname"
              placeholder="Dein Eventname"
              rules="required|min:2"
              class="block mt-6"
              autocomplete="off"
            />
          </div>

          <div class="configuration-wizard-create-event__event-date mt-8 w-full md:mt-0 md:w-1/2">
            <mj-input-label
              for="eventdate"
              class="text-xl text-gray-900"
            >
              Wann wird dein erstes Event stattfinden?
            </mj-input-label>
            <p class="text-gray-700 text-xs">
              Du kannst das Datum im nachhinein jederzeit ändern.
            </p>
            <mj-date-picker
              popover-direction="top"
              @pick="onPick"
            >
              <mj-validation-input-field
                v-model="eventForm.starts_on"
                name="eventdate"
                placeholder="TT.MM.YYYY"
                class="block mt-6"
                autocomplete="off"
                :rules="{required: true, regex: /\d{2}(\.|-)\d{2}(\.|-)\d{4}/ }"
              />
            </mj-date-picker>
          </div>
        </div>
        <div class="flex flex-col w-full md:flex-row">
          <div class="w-full md:w-1/3 mb-16 text-right md:text-left">
            <mj-button
              class="btn-primary"
              :is-busy="isBusy"
              @click="onSubmit"
            >
              Event erstellen
            </mj-button>
          </div>
          <div class="w-full md:w-2/3">
            <mj-icon
              src="media-player"
              class="w-full h-auto"
              proportions="rectangle"
            />
          </div>
        </div>
      </mj-validation-observer>
    </mj-configuratin-wizard-content>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { format, parse } from 'date-fns';
import ConfigurationWizardHeader from '@/components/configuration-wizard/ConfigurationWizardHeader.vue';
import ConfigurationWizardContent from '@/components/configuration-wizard/ConfigurationWizardContent.vue';
import ConfigurationWizardProgressBar from '@/components/configuration-wizard/ConfigurationWizardProgressBar.vue';
import DatePicker from '@/components/date-picker/DatePicker.vue';

export default {
  name: 'ConfigurationWizardCreateEvent',

  components: {
    'mj-configuratin-wizard-header': ConfigurationWizardHeader,
    'mj-configuratin-wizard-content': ConfigurationWizardContent,
    'mj-configuratin-wizard-progress-bar': ConfigurationWizardProgressBar,
    'mj-date-picker': DatePicker,
  },

  data() {
    return {
      eventForm: {
        name: null,
        starts_on: null,
      },
      pickedDate: null,
      progressLabels: [
        { name: '1. Spotify autorisieren', isActive: false, isComplete: true },
        { name: '2. Event erstellen', isActive: true, isComplete: false },
        { name: '3. Los gehts', isActive: false, isComplete: false },
      ],
      isBusy: false,
    };
  },

  watch: {
    pickedDate(newDate) {
      this.eventForm.starts_on = format(newDate, 'dd.MM.yyyy');
    },
  },

  methods: {
    ...mapActions(['createEvent', 'finishWizard']),

    onPick({ date }) {
      this.pickedDate = date;
    },

    async onSubmit() {
      if (await this.$refs.formObserver.validate()) {
        const eventData = {
          name: this.eventForm.name,
          starts_on: format(parse(this.eventForm.starts_on, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd'),
        };
        this.isBusy = true;
        this.createEvent(eventData)
          .then(() => {
            this.finishWizard();
            this.$router.push({ name: 'configuration.wizard.lets.go' });
          })
          .catch(({ response }) => {
            let eventnameError = 'Eventname ist ein Pflichtfeld';
            let eventdateError = '';
            if (response.data.errors.name !== undefined) {
              eventnameError = response.data.errors.name;
            }

            if (response.data.errors.starts_on !== undefined) {
              eventdateError = response.data.errors.starts_on;
            }
            this.$refs.formObserver.setErrors({
              eventname: eventnameError,
              eventdate: eventdateError,
            });
          })
          .finally(() => { this.isBusy = false; });
      }
    },
  },

};

</script>
